var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarRectangleShapeBgDoctrXWebflowTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1292,
    height: 401,
    viewBox: "0 0 1292 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1292,
    height: 400.457,
    fill: "#3D65FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_30743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1292,
    height: 401
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1292,
    height: 400.457,
    fill: "#3D65FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_30743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.158 439.493L-216.409 731.878C-304.013 781.177 -335.065 892.158 -285.766 979.761C-236.468 1067.36 -125.487 1098.42 -37.8833 1049.12L1103.55 406.782C1289.7 302.022 1355.69 66.1873 1250.93 -119.97L1218.84 -176.99C1131.81 -331.656 935.865 -386.479 781.199 -299.441C700.794 -254.193 643.716 -176.568 624.498 -86.3294L597.874 38.6835C561.729 208.4 454.38 354.393 303.158 439.493Z",
    fill: "#AAEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.672 667.86L-87.8956 960.245C-175.499 1009.54 -206.551 1120.53 -157.253 1208.13C-107.954 1295.73 3.0269 1326.78 90.6303 1277.49L1232.06 635.149C1418.22 530.389 1484.2 294.554 1379.44 108.397L1347.36 51.3776C1260.32 -103.289 1064.38 -158.112 909.713 -71.0741C829.307 -25.8262 772.229 51.7989 753.011 142.038L726.387 267.051C690.243 436.767 582.894 582.76 431.672 667.86Z",
    fill: "#0CB9F1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarRectangleShapeBgDoctrXWebflowTemplate);
export default __webpack_public_path__ + "static/media/bar-rectangle-shape-bg-doctr-x-webflow-template.5bf70715bd6b407d52bb221ed7b04bc8.svg";
export { ForwardRef as ReactComponent };